import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

export const AskForAllModalAllSentConfirmation = () => {
    return (
        <div css={contentWrap}>
            <Text variant="headline_3" css={[m(0, 0, 5, 0)]}>
                Twoje zapytania zostały wysłane
            </Text>
            <Text variant="body_copy_1" css={message}>
                Możesz ponownie uzupełnić listę i wysłać nowe zapytania
            </Text>
            <Button variant="filled_primary" href={rpAppLink.base()}>
                Przejdź do strony głównej
            </Button>
        </div>
    );
};

/*
    Styles
 */
const contentWrap = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${p(5, 1.5, 5, 1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(3, 3, 6, 3)}
    }
`;

const message = (theme: Theme) => css`
    ${m(0, 0, 4, 0)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${m(0, 0, 3, 0)}
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

export const AskForAllModalAllSentConfirmation = () => {
    return (
        <div css={contentWrap}>
            <Text variant="headline_3" css={[m(0, 0, 5, 0)]}>
                Twoje zapytania zostały wysłane
            </Text>
            <Text variant="body_copy_1" css={message}>
                Możesz ponownie uzupełnić listę i wysłać nowe zapytania
            </Text>
            <Button variant="filled_primary" href={rpAppLink.base()}>
                Przejdź do strony głównej
            </Button>
        </div>
    );
};

/*
    Styles
 */
const contentWrap = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${p(5, 1.5, 5, 1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(3, 3, 6, 3)}
    }
`;

const message = (theme: Theme) => css`
    ${m(0, 0, 4, 0)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${m(0, 0, 3, 0)}
    }
`;
